const HomePage = () => {
  return (
    <>
      <h1 className="mt-4 text-center justify-content-center w-100">Tip Hotline Form</h1>

      <iframe
        id="JotFormIFrame-230726828875065"
        title="Tip Hotline Reporting Form"
        onLoad={window.parent.scrollTo(0, 0)}
        allowtransparency="true"
        allowFullScreen={true}
        allow="geolocation; microphone; camera"
        src="https://utahcounty.jotform.com/230726828875065"
        frameBorder="0"
        style={{ minWidth: '100%', maxWidth: '100%', height: '700px', border: 'none' }}
        scrolling="yes"
      ></iframe>
    </>
  );
};

export default HomePage;
